import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/content";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-186" data-mp="urkoi91u8h5h">
      <div className="mx-auto max-w-3xl" data-id="element-187" data-mp="70f21b1e6qm7">
        <SectionHeading eyebrow="Frequently asked questions" title="Answers before you decide" data-id="element-188" data-mp="71glo3wh4lfj" />
        <div className="mt-10 divide-y divide-line rounded-2xl ring-1 ring-line" data-id="element-189" data-mp="23ybka6q005y">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-190" data-mp="bzi8mzx0t4wa" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left" data-id="element-191" data-mp="c2e2ac1u57ex">
                  <span className="font-display text-base font-extrabold leading-snug text-ink md:text-lg" data-id="element-192" data-mp="ht7ispaw5rye">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-cta text-white" : "bg-paper text-ink"}`} data-id="element-193" data-mp="muww6bll6hpn">
                    <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-194" data-mp="3v6sse1hlsvl8" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-195" data-mp="8464r4nwpkn2">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-196" data-mp="cumi6orq969f">
                      <p className="px-5 pb-5 text-base leading-relaxed text-muted" data-id="element-197" data-mp="nnodb9y17371">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <div className="mt-10" data-id="element-198" data-mp="xgvhirh1cd5j">
          <CtaButton label="I’m ready — get the blueprint" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-199" data-mp="sfpikbws7tnk" />
        </div>
      </div>
    </section>;
}